import SubHeader from '../../layout/components/SubHeader';
import EyeDrawHome from './EyeDrawHome';
import './EyeDraw.css';

const TEMPLATE_COUNT = 29;

function EyeDrawNew() {
    return (
        <div className="ecx-page eye-draw-page">
            <SubHeader
                title="Eye Draw"
                description={`Illustrate eye conditions on clinical templates · ${TEMPLATE_COUNT} templates`}
                icon="bi-easel"
                containerClass="container-fluid px-4"
            />
            <div className="container-fluid px-4 py-3">
                <EyeDrawHome />
            </div>
        </div>
    );
}

export default EyeDrawNew;
